import { useI18n } from "../../../i18n";
import { DateField } from "../../../components/common/DateField";

const inputCls = "mt-1 h-11 w-full rounded-xl border border-slate-200 bg-white px-3 text-sm text-navy outline-none focus:border-brand focus:ring-4 focus:ring-brand/15";

const Field = ({ label, children }) => (
  <label className="block min-w-0">
    <span className="text-xs font-medium text-slate-500">{label}</span>
    {children}
  </label>
);

export const TestParams = ({ params, setParams, customers, items }) => {
  const { t, lang } = useI18n();
  const set = (k) => (e) => setParams({ ...params, [k]: e.target.value });
  const setDate = (k) => (v) => setParams({ ...params, [k]: v });
  return (
    <div className="grid grid-cols-2 gap-3 lg:grid-cols-4" data-testid="softone-params">
      <Field label={t("softone.customer")}>
        <select value={params.customer_code} onChange={set("customer_code")} className={inputCls} data-testid="softone-customer-select">
          {customers.map((c) => <option key={c.code} value={c.code}>{c.code} · {c.name}</option>)}
        </select>
      </Field>
      <Field label={t("softone.item")}>
        <select value={params.item_code} onChange={set("item_code")} className={inputCls} data-testid="softone-item-select">
          {items.map((i) => <option key={i.code} value={i.code}>{i.code} · {i[`name_${lang}`]}</option>)}
        </select>
      </Field>
      <Field label={t("softone.dateFrom")}><DateField value={params.date_from} onChange={setDate("date_from")} testId="softone-date-from" /></Field>
      <Field label={t("softone.dateTo")}><DateField value={params.date_to} onChange={setDate("date_to")} testId="softone-date-to" /></Field>
      <Field label={t("softone.months")}><input type="number" min="1" max="36" value={params.months} onChange={set("months")} className={inputCls} data-testid="softone-months" /></Field>
      <Field label={t("softone.updatedSince")}><DateField value={params.updated_since} onChange={setDate("updated_since")} testId="softone-updated-since" /></Field>
      <Field label={t("softone.docNo")}><input value={params.doc_no} onChange={set("doc_no")} placeholder="TEST26-00001" className={inputCls} data-testid="softone-doc-no" /></Field>
    </div>
  );
};
